import { toast } from "react-toastify";
import i18n from "../translate/i18n";

const toastError = err => {
  const errorMsg = err?.response?.data?.error;
  // auto-fecha em 5s (herda o autoClose do ToastContainer) — não persiste
  if (errorMsg) {
    toast.error(errorMsg, { toastId: errorMsg });
  } else {
    toast.error(i18n.t("errors.generic"), { toastId: "generic" });
  }
};

export default toastError;
